"use client"

import { useState, useEffect, useRef } from "react"

const ProductModal = ({ product, onClose }) => {
  const modalRef = useRef(null)
  const imageRef = useRef(null)
  const overlayRef = useRef(null)
  const [imageLoaded, setImageLoaded] = useState(false)

  // Handle click outside to close modal
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose()
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [onClose])

  // Setup zoom functionality
  useEffect(() => {
    const imageElement = imageRef.current
    const overlayElement = overlayRef.current

    if (!imageElement || !overlayElement || !imageLoaded) return

    const handleMouseMove = (e) => {
      const { left, top, width, height } = imageElement.getBoundingClientRect()

      // Calculate mouse position as percentage
      const x = ((e.clientX - left) / width) * 100
      const y = ((e.clientY - top) / height) * 100

      // Update background position of overlay
      overlayElement.style.backgroundPosition = `${x}% ${y}%`
    }

    const imageContainer = imageElement.parentElement
    imageContainer.addEventListener("mousemove", handleMouseMove)

    return () => {
      imageContainer.removeEventListener("mousemove", handleMouseMove)
    }
  }, [imageLoaded])

  const handleImageLoad = () => {
    setImageLoaded(true)

    // Set the background image for the zoom overlay
    if (overlayRef.current && imageRef.current) {
      overlayRef.current.style.backgroundImage = `url('${imageRef.current.src}')`
    }
  }

  return (
    <div className="product-modal" onClick={onClose}>
      <div className="product-modal-content" ref={modalRef} onClick={(e) => e.stopPropagation()}>
        <span className="close-modal" onClick={onClose}>
          ×
        </span>

        <div className="modal-image-section">
          <div className="image-wrapper">
            <img
              ref={imageRef}
              src={process.env.PUBLIC_URL + product.imageUrl || "/placeholder.svg"}
              alt={product.name}
              className="product-image-main"
              onLoad={handleImageLoad}
              onError={(e) => {
                e.target.onerror = null
                e.target.src = "/placeholder.svg?height=400&width=400"
              }}
            />
            <div ref={overlayRef} className="zoom-overlay"></div>
          </div>
        </div>

        <div className="modal-details">
          <h3>{product.name}</h3>
          <p>{product.description}</p>

          <div className="modal-info-grid">
            <div className="info-item">
              <h4>Price</h4>
              <p className="price">${product.price}</p>
            </div>
            <div className="info-item">
              <h4>Availability</h4>
              <p>{product.availability > 0 ? `In Stock (${product.availability})` : "Out of Stock"}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductModal
